/**
 * Shopify Search & Discovery Filter Translation Script
 * Reliably translates filters including after AJAX updates
 */

(function() {
  'use strict';

  let translations = null;

  /**
   * Load translations from embedded global variable
   */
  function loadTranslations() {
    if (typeof window.filterTranslations !== 'undefined') {
      translations = window.filterTranslations;
      return true;
    }
    return false;
  }

  /**
   * Get translation for a key path
   */
  function getTranslation(keyPath, defaultValue) {
    if (!translations) return defaultValue;
    
    const keys = keyPath.split('.');
    let value = translations;
    
    for (const key of keys) {
      if (value && typeof value === 'object' && key in value) {
        value = value[key];
      } else {
        return defaultValue;
      }
    }
    
    return value || defaultValue;
  }

  /**
   * Normalize value for translation key lookup
   */
  function normalizeValue(value) {
    return value
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '_')
      .replace(/[^a-z0-9_-]/g, '');
  }

  /**
   * Check if text is already translated
   */
  function isAlreadyTranslated(element, prefix, originalText) {
    const normalizedValue = normalizeValue(originalText);
    const translatedText = getTranslation(`${prefix}.${normalizedValue}`, originalText);
    
    // If the current text matches the translation, it's already translated
    return element.textContent.trim() === translatedText;
  }

  /**
   * Translate text in an element
   */
  function translateText(element, prefix) {
    if (!element) return;

    const originalText = element.textContent.trim();
    if (!originalText) return;

    // Check if already translated
    if (isAlreadyTranslated(element, prefix, originalText)) {
      return;
    }

    const normalizedValue = normalizeValue(originalText);
    const translatedText = getTranslation(`${prefix}.${normalizedValue}`, originalText);
    
    if (translatedText !== originalText) {
      element.textContent = translatedText;
    }
  }

  /**
   * Make express delivery bold
   */
  function makeBold(element) {
    if (!element) return;
    
    const text = element.textContent.toLowerCase();
    if (text.includes('express') || text.includes('24') || text.includes('48') || text.includes('entrega')) {
      element.style.fontWeight = 'bold';
    }
  }

  /**
   * Process filters
   */
  function processFilters() {
    if (!translations) return;

    // Define filter mappings - ID pattern to translation prefix
    const filterMappings = [
      { pattern: 'most_searched', prefix: 'most_searched', makeBold: true },
      { pattern: 'lens_effect', prefix: 'lens_effect', makeBold: false },
      { pattern: 'style', prefix: 'style', makeBold: false },
      { pattern: 'lens-type', prefix: 'lens-type', makeBold: false },
      { pattern: 'rim', prefix: 'rim', makeBold: false },
      { pattern: 'fabric', prefix: 'fabric', makeBold: false },
      { pattern: 'eyewear-frame-design', prefix: 'eyewear-frame-design', makeBold: false },
      { pattern: 'target-gender', prefix: 'genders', makeBold: false }
    ];

    // Process each filter type
    filterMappings.forEach(({ pattern, prefix, makeBold: shouldBold }) => {
      // Find all filter containers that match this pattern
      const filterContainers = document.querySelectorAll(`details[id*="${pattern}"]`);
      
      filterContainers.forEach(container => {
        // Find all text labels within this filter (removed :not selector to always check)
        const labels = container.querySelectorAll('.facet-checkbox__text-label');
        
        labels.forEach(label => {
          translateText(label, prefix);
          if (shouldBold) {
            makeBold(label);
          }
        });
      });
    });
  }

  /**
   * Safe initialization
   */
  function initialize() {
    if (!loadTranslations()) {
      console.warn('Filter translations not loaded');
      return;
    }

    // Initial processing
    setTimeout(processFilters, 100);

    // Watch for filter updates with MutationObserver
    const observer = new MutationObserver(() => {
      processFilters();
    });

    // Observe the main content area
    const mainContent = document.querySelector('main, #MainContent, .facets-container');
    if (mainContent) {
      observer.observe(mainContent, {
        childList: true,
        subtree: true
      });
    }

    // Listen for Shopify facet update events
    document.addEventListener('facet:update', () => {
      setTimeout(processFilters, 100);
    });

    // Listen for filter clicks (both desktop and mobile)
    document.addEventListener('click', (e) => {
      const isFilterClick = e.target.closest(
        'details.mobile-facets__details, ' +
        'details.facets__disclosure, ' +
        '.mobile-facets__checkbox, ' +
        '.facets__checkbox, ' +
        'input[type="checkbox"][name*="filter"]'
      );
      
      if (isFilterClick) {
        setTimeout(processFilters, 300);
      }
    });

    // Periodically check and translate (fallback for edge cases)
    setInterval(processFilters, 2000);
  }

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();